<template>
  <v-dialog
      v-model="showDialog"
      :max-width="dialogMaxWidth === undefined ? '55vw' : dialogMaxWidth"
      persistent
      scrollable
      @keydown.esc="closeDialog"
  >
    <v-card class="card-modal">
      <v-btn
        v-if="showCloseBtn === undefined ? true : showCloseBtn"
        class="card-title-close-btn"
        @click.stop="$emit('close')"
        aria-label="Close Modal"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <hr id="hr-title" />
      <v-card-text>
        <slot name="body" class="body-content"></slot>
      </v-card-text>
      <hr id="hr-action-btns"/>
      <v-card-actions style="padding-top: 10px">
        <v-btn
          v-if="showCancelButton === undefined ? false : showCancelButton"
          @click.stop="$emit('close')"
        >
          {{ cancelButton === undefined ? $t('buttons.cancel') : cancelButton}}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="showMainBtn"
          class="btn-primary"
          :color="confirmButtonColor || 'primary'"
          @click.stop="$emit('confirmed')"
          :disabled="confirmEnabled === undefined ? false : !confirmEnabled"
        >
          {{ confirmButton || $t('buttons.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import '../../style/_variables.scss'

export default {
  name: 'base-modal',
  props: [
    'title',
    'body',
    'cancelButton',
    'showCancelButton',
    'confirmButton',
    'confirmButtonColor',
    'confirmEnabled',
    'customShowDialog',
    'dialogMaxWidth',
    'hasMainBtn',
    'showCloseBtn'
  ],
  methods: {
    closeDialog () {
      this.showDialog = false
      this.$emit('close')
    }
  },
  computed: {
    showDialog: function () {
      return this.customShowDialog !== undefined ? this.customShowDialog : true
    },
    showMainBtn: function () {
      return this.hasMainBtn === undefined ? true : this.hasMainBtn
    }
  }
}
</script>

<style lang="scss" scoped>
// @todo - modify modal.css for rounded corners
.card {
  border-radius: $padding-dialog-radius;
}
.card__title {
  padding: 0 0 $length-small-l $padding-dialog-quarter;
}
#hr-title {
  border-top: $length-small-s solid $black-900;
}
#hr-action-btns {
  border-top: $length-small-s solid $grey-500;
}
.btn {
  background-color: $grey-400;
  min-width: $length-xlarge-l;
  min-height: $length-large-xs;
  border-radius: $length-med-xs;
  text-transform: capitalize;
  font-size: $font-size-med;
  color: $grey-800;
  &-primary {
    color: white;
  }
}
.card-title-close-btn {
  min-width: 50px;
  min-height: 50px;
  aspect-ratio: 1;
  position: absolute;
  right: 50px;
  top: 10px;
  box-shadow: unset;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/BaseModal.vue